import { PriceRules } from '@gorampe/catalog-adapter';

export function computeTransport(
  kmAller: number,
  withUninstall: boolean,
  tarifs: PriceRules['transportPerKm'],
): number {
  return (
    Math.round(kmAller * (withUninstall ? tarifs.withUninstall : tarifs.withoutUninstall) * 100) /
    100
  );
}
